import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import './Dropdown.css';

const DEFAULT_PLACEHOLDER_STRING = 'Select...';

class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.value || {
                label: typeof props.placeholder === 'undefined' ? DEFAULT_PLACEHOLDER_STRING : props.placeholder,
                value: ''
            },
            isOpen: false,
            offsetTop: 0
        };
        this.mounted = true;
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.fireChangeEvent = this.fireChangeEvent.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick, false);
        document.addEventListener('touchend', this.handleDocumentClick, false);
        window.addEventListener('resize', this.handleResize, false);

        setTimeout(this.handleResize, 100);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.selected) {
            this.setState({ selected: newProps.value });
        } else if (!newProps.value) {
            this.setState({
                selected: {
                    label: typeof newProps.placeholder === 'undefined' ? DEFAULT_PLACEHOLDER_STRING : newProps.placeholder,
                    value: ''
                }
            });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        document.removeEventListener('click', this.handleDocumentClick, false);
        document.removeEventListener('touchend', this.handleDocumentClick, false);
        window.removeEventListener('resize', this.handleResize, false);
    }

    handleResize() {
        var n = ReactDOM.findDOMNode(this);
        this.setState({
            offsetTop: n.getBoundingClientRect().top
        });
    }

    handleMouseDown(event) {
        if (this.props.onFocus && typeof this.props.onFocus === 'function') {
            this.props.onFocus(this.state.isOpen);
        }
        if (event.type === 'mousedown' && event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();

        if (!this.props.disabled) {
            this.setState({
                isOpen: !this.state.isOpen
            });
        }
    }

    setValue(option) {
        let newState = {
            selected: option,
            isOpen: false
        };
        this.fireChangeEvent(newState);
        this.setState(newState);
    }

    fireChangeEvent(newState) {
        if (newState.selected !== this.state.selected && this.props.onChange) {
            this.props.onChange(newState.selected);
        }
    }

    renderOption(option, index) {
        const classes = {
            [`${this.props.baseClassName}-option`]: true,
            [option.className]: !!option.className,
            'is-selected': option === this.state.selected
        };

        const optionClass = classNames(classes);

        let value = option.value || `option-${index}`;
        let label = option.label || value;

        return (
            <div
                key={`${value}-${index}`} // ✅ Nu bruger vi både value og index for at sikre unikke keys
                className={optionClass}
                onMouseDown={this.setValue.bind(this, option)}
                onClick={this.setValue.bind(this, option)}
            >
                {option.thumbnail ? <img alt={label} src={option.thumbnail} /> : null}
                {label}
                {option.description ? <span>{option.description}</span> : null}
            </div>
        );
    }


    buildMenu() {
        let { options, baseClassName } = this.props;
        let ops = options.map((option, index) => {
            return this.renderOption(option, index);
        });

        return ops.length ? ops : <div className={`${baseClassName}-noresults`}>No options found</div>;
    }


    handleDocumentClick(event) {
        if (this.mounted) {
            if (!ReactDOM.findDOMNode(this).contains(event.target)) {
                if (this.state.isOpen) {
                    this.setState({ isOpen: false });
                }
            }
        }
    }

    render() {
        const { baseClassName, controlClassName, placeholderClassName, menuClassName, arrowClassName, className } = this.props;

        const disabledClass = this.props.disabled ? 'Dropdown-disabled' : '';
        const placeHolderValue = typeof this.state.selected === 'string' ? this.state.selected : this.state.selected.label;

        const dropdownClass = classNames({
            [`${baseClassName}-root`]: true,
            [className]: !!className,
            'is-open': this.state.isOpen,
            'small': this.props.small
        });
        const controlClass = classNames({
            [`${baseClassName}-control`]: true,
            [controlClassName]: !!controlClassName,
            [disabledClass]: !!disabledClass
        });
        const placeholderClass = classNames({
            [`${baseClassName}-placeholder`]: true,
            [placeholderClassName]: !!placeholderClassName
        });
        const menuClass = classNames({
            [`${baseClassName}-menu`]: true,
            [menuClassName]: !!menuClassName
        });
        const arrowClass = classNames({
            [`${baseClassName}-arrow`]: true,
            [arrowClassName]: !!arrowClassName
        });

        const bodyHeight = document.body.scrollHeight;
        const menuHeight = Math.min(400, 38 * this.props.options.length);

        const offset = Math.max(0, (this.state.offsetTop + 45 + menuHeight) - bodyHeight);

        const value = (
            <div className={placeholderClass}>
                {this.state.selected.thumbnail ? <img alt={placeHolderValue} src={this.state.selected.thumbnail} /> : null}
                {placeHolderValue}
                {this.state.selected.description ? <span>{this.state.selected.description}</span> : null}
            </div>
        );

        const menu = this.state.isOpen ? <div className={menuClass} style={{marginTop:-offset}}>{this.buildMenu()}</div> : null;


        return (
            <div className={dropdownClass} style={this.props.style}>
                <div className={controlClass} onMouseDown={this.handleMouseDown.bind(this)} onTouchEnd={this.handleMouseDown.bind(this)}>
                    {value}
                    <span className={arrowClass} />
                </div>
                {menu}
            </div>
        );
    }
}

Dropdown.defaultProps = { baseClassName: 'Dropdown' };
export default Dropdown;



// WEBPACK FOOTER //
// ./src/Dropdown.js